import { render } from "./Subcategories.vue?vue&type=template&id=0b791252"
import script from "./Subcategories.vue?vue&type=script&lang=js"
export * from "./Subcategories.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__